<template>
  <div class="listform">
    <div class="form-title">经销商提货记录
      <Icon type="briefcase"></Icon>
      <Button style="margin-left: 30px;" type="primary" @click="GoBack()" icon="md-arrow-back">返回</Button>

    </div>
    <div class="search_option">
    </div>
    <div class="datatable">
      <Table :border="false"  size="small" @on-sort-change="Sort" :columns="table.tablecolumsTitle" :loading="table.loading" :data="table.datalist"></Table>
    </div>
    <div class="footerpage">
      <Page :total="table.total" :page-size="table.pageSize" @on-change="PageChange" :current="table.pageIndex" show-elevator></Page>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      queryvalue: "",
      sel_field: "",

      sel_values: [
        { value: "Name", label: "姓名" },
        { value: "Tel", label: "电话" }
      ],
      table: {
        tablecolumsTitle: [
          {
            title: "积分变更数量",
            key: "ChangeCashIntegral",
            align: "center",
            tooltip: true
          },
          {
            title: "变更类型",
            key: "DataSourceDesc",
            align: "center",
            tooltip: true
          },
          {
            title: "备注",
            key: "Remark",
            align: "center",
            tooltip: true
          },
          {
            title: "变更时间",
            key: "_CreateTime",
            align: "center",
            tooltip: true
          }
        ],
        datalist: [],
        pageIndex: 1,
        total: 0,
        pageSize: 1,
        loading: true,
        sort: " "
      },
      dist_modal: {
        currentdealer: 0,
        show: false,
        distnum: 0
      }
    };
  },
  methods: {
    PageChange: function(e) {
      this.table.pageIndex = e;
      this.GetTableList();
      this.$router.push({
        name: "dealer_childdealercaintegrallog",
        params: { dealerid: this.$route.params.dealerid }
      });
    },
    GetTableList: function() {
      var conditions = [];
      conditions.push({
        PropertyName: "DealerId",
        Operater: 2,
        LogicOperater: 0,
        Value: this.$route.params.dealerid
      });

      this.$http.SetConditions(conditions);
      var that = this;
      that.table.loading = true;
      this.$http
        .get("Dealer/GetCaIntegralLogPageList", {
          params: { pageIndex: that.table.pageIndex, sort: that.table.sort }
        })
        .then(res => {
          that.table.loading = false;
          res.data.ListData.map(item => {
            item.DataSourceDesc =
              (item.DataSource == 1 && "误工积分消分获得") ||
              (item.DataSource == 0 && "现金积分提货") ||
              "数据异常";
          });
          that.table.datalist = res.data.ListData;
          that.table.total = res.data.TotalCount;
          that.table.pageSize = res.data.PageSize;
        });
    },
    Sort: function(sort) {
      if (sort.key != undefined && sort.order != undefined) {
        if (sort.order != "normal") {
          this.table.sort = sort.key + " " + sort.order;
        } else {
          this.table.sort = "";
        }
      }
      this.GetTableList();
    },
    Search: function(e) {
      this.loading = true;
      var conditions = [];
      if (this.sel_field != "" && this.queryvalue.trim() != "") {
        conditions.push({
          PropertyName: this.sel_field,
          Operater: 0,
          LogicOperater: 0,
          Value: this.queryvalue.trim()
        });
      }
      this.$http.SetConditions(conditions);
      this.GetTableList();
    },
    GoBack: function(e) {
      this.$http.SetConditions();
      this.$router.go(-1);
    }
  },
  created: function() {
    this.GetTableList();
  }
};
</script>
<style>
</style>
 